import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { QuestionViewerComponent } from './question-viewer/question-viewer.component';

import { TopbarComponent } from './topbar/topbar.component';
import { IntroScreenComponent } from './intro-screen/intro-screen.component';
import { ExplanationComponent } from './explanation/explanation.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    VideoPlayerComponent,
    QuestionViewerComponent,
    TopbarComponent,
    ExplanationComponent,
    IntroScreenComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {}
